export default __webpack_public_path__ + "static/media/noon.b1b3c043.svg";